export const GET_CAROUSEL_IMAGES = 'GET_CAROUSEL_IMAGES'
export const GET_ATTRACT_LOOP_IMAGES = 'GET_ATTRACT_LOOP_IMAGES'
export const GET_CAROUSEL_IMAGES_SUCCESS = 'GET_CAROUSEL_IMAGES_SUCCESS'
export const GET_CAROUSEL_IMAGES_LOADING = 'GET_CAROUSEL_IMAGES_LOADING'
export const GET_CAROUSEL_IMAGES_FAILURE = 'GET_CAROUSEL_IMAGES_FAILURE'

export const getCarouselImages = () => ({
  type: GET_CAROUSEL_IMAGES,
})

export const getAttractLoopImages = () => ({
  type: GET_ATTRACT_LOOP_IMAGES,
})

export const getCarouselImagesFailure = () => ({
  type: GET_CAROUSEL_IMAGES_FAILURE,
})

export const getCarouselImagesSuccess = (payload) => ({
  type: GET_CAROUSEL_IMAGES_SUCCESS,
  payload,
})

export const setCarouselImagesLoading = () => ({
  type: GET_CAROUSEL_IMAGES_LOADING,
})
